import { createAction, props } from '@ngrx/store';
import { IEstensaButtonStatus, IEstensaButtonStatusWithChildren } from '../../../models/vnext.models';

import { ToolbarAction, ToolbarButtonData, ToolbarSliderOptions, ToolbarTimelineOptions } from '../types';

export const seToolbarButtonPressed = createAction(
    '[Se] ToolbarButtonPressed',
    props<{ button: ToolbarAction; payload?: any; idCardioWebServiceForExtUrlToken?: string }>(),
);

export const seToolbarButtonEnable = createAction(
    '[SeToolbar] ButtonEnable',
    props<{ button: ToolbarAction; enabled: boolean }>(),
);

export const setToolbarButtonsEnableBulk = createAction(
    '[SeToolbar] ButtonsEnableBulk',
    props<{ buttons: { button: ToolbarAction; enabled: boolean }[] }>(),
);

export const seToolbarButtonHide = createAction(
    '[SeToolbar] ButtonHide',
    props<{ button: ToolbarAction; hidden: boolean }>(),
);

export const seToolbarButtonToggle = createAction(
    '[SeToolbar] ButtonToggle',
    props<{ button: ToolbarAction; checked: boolean }>(),
);

export const seToolbarInitialize = createAction(
    '[SeToolbar] Initialize',
    props<{
        buttons: ToolbarButtonData[];
        leftSlider: ToolbarSliderOptions;
        rightSlider: ToolbarSliderOptions;
        timeline?: ToolbarTimelineOptions;
    }>(),
);

export const seToolbarInitializeButtons = createAction(
    '[SeToolbar] InitializeButtons',
    props<{ buttons: ToolbarButtonData[] }>(),
);

export const seToolbarSetAllButtons = createAction(
    '[SeToolbar] SetAllButtons',
    props<{ buttons: Partial<Record<ToolbarAction, IEstensaButtonStatus | IEstensaButtonStatusWithChildren>> }>(),
);

export const seToolbarSetButton = createAction(
    '[SeToolbar] SetButton',
    props<{ action: ToolbarAction; button: Partial<ToolbarButtonData> }>(),
);

export const seToolbarSetButtonsBulk = createAction(
    '[SeToolbar] SetButton',
    props<{ buttons: { action: ToolbarAction; button: Partial<ToolbarButtonData> }[] }>(),
);

export const seToolbarSetLeftSlider = createAction(
    '[SeToolbar] SetLeftSlider',
    props<{ status: ToolbarSliderOptions }>(),
);

export const seToolbarSetRightSlider = createAction(
    '[SeToolbar] SetRightSlider',
    props<{ status: ToolbarSliderOptions }>(),
);

export const seToolbarSetCpRightSlider = createAction(
    '[SeToolbar] SetCpRightSlider',
    props<{ status: ToolbarSliderOptions; params: any }>(),
);

export const seToolbarSetButtonChildren = createAction(
    '[SeToolbar] seToolbarAddChildren',
    props<{ button: ToolbarAction; children: ToolbarButtonData[] }>(),
);

export const seToolbarSetTimeline = createAction(
    '[SeToolbar] SetTimeline',
    props<{ status: ToolbarTimelineOptions }>(),
);

export const seToolbarSetTooltip = createAction(
    '[SeToolbar] SetTooltip',
    props<{ action: ToolbarAction; tooltip: string; }>(),
);

export const seToolbarToggleLeftSlider = createAction('[SeToolbar] ToggleLeftSlider');

export const seToolbarToggleRightSlider = createAction('[SeToolbar] ToggleRightSlider');

export const seToolbarToggleTimeline = createAction('[SeToolbar] ToggleTimeline');

export const seToolbarDisableAllButtons = createAction('[SeToolbar] DisableAllButtons');
